export class UniformBufferBlock {
    constructor(cluster, index, size, alignedSize, user) {
        this._destroyed = false;
        this._id = UniformBufferBlock._idCounter++;
        this.cluster = cluster;
        this.index = index;
        this.size = size;
        this._alignedSize = alignedSize;
        this.offset = alignedSize * index;
        this.user = user;
        this.uploadNum = 0;
        this.moved = false;
    }
    needUpload() {
        this.cluster._addUploadBlock(this.index);
        if (!this.moved && this.uploadNum++ > this.cluster.manager.uploadThreshold)
            this.cluster.manager._addOptimizeBufferPos(this.cluster);
    }
    destroy() {
        if (!this._destroyed) {
            this._destroyed = true;
            this.cluster = null;
            this.user = null;
            return true;
        }
        console.warn('UniformBufferBlock: object alreay destroyed!');
        return false;
    }
}
UniformBufferBlock._idCounter = 0;
